export class Column {
  public name: string | undefined;
  public label: string | undefined;
  public displayLabel: string | undefined;
  public field: string | undefined;
  public hidden: boolean | undefined;
  public sortable = false;
}